<template lang="pug">
.nba-container(v-if="additionalZone.additionalGoodDTOList && additionalZone.additionalGoodDTOList.length")
  .nba-super-card()
    .card-header {{additionalZone.additionalZoneTitle}}
    .card-content
      .list-item(
        :class="{'two': additionalZone.additionalGoodDTOList.length > 2,'backgroundBg': item.joinMemberBackgroundImage}"
        v-for="item in additionalZone.additionalGoodDTOList"
        :style="item.joinMemberBackgroundImage ? `background-image: url(${item.joinMemberBackgroundImage})` : additionalZone.additionalGoodDTOList.length > 2 ? `background-image: url(https://m.hellobike.com/resource/gallery/350/e1aUH-A6_nba-bg-shot.png)`: `background-image: url(https://m.hellobike.com/resource/gallery/350/nSyGQwHY_nba-bg-card.png)`"
        @click="handleClick(item)"
      )
        .item-bg(v-if="item.unOpenCardImgUrl")
          .item-icon
            img(:src="item.unOpenCardImgUrl")
        .item-name(v-if="item.additionalName") {{item.additionalName}}
        .item-desc(v-if="item.propertyVersionName") +{{item.propertyVersionName}}
        .item-price(v-if="item.markedPrice") 价值¥{{item.markedPrice}}
        .item-btn(v-if="item.signInfoDTO")
          span.normal ¥
          span.price {{item.signInfoDTO.firstSignPrice}}
          span.normal /月
</template>
<script>
import { env } from '@hb/hbridge';

export default {
  components: {

  },
  props: {
    vipData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      env,
      additionalZone: {},
    };
  },
  watch: {
    vipData(val) {
      this.additionalZone = val.goodsList[0].additionalZone || {};
    },
  },
  mounted() {
    this.additionalZone = this.vipData.goodsList[0].additionalZone || {};
  },
  methods: {
    handleClick(data) {
      if (!data.joinMemberBackgroundImage) {
        this.$emit('openModal', data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nba-container {
  width: 100%;
  padding: 0 0.12rem;
  margin-top: 0.05rem;

  .nba-super-card {
    width: 3.51rem;
    height: 2.36rem;
    background-color: #fff;
    border: 0.005rem solid #ebeef0;
    border-radius: 0.16rem;
    padding: 0.12rem 0 0 0.15rem;

    .card-header {
      width: 100%;
      height: 0.22rem;
      font-weight: 600;
      color: #242729;
      display: flex;
    }

    .card-content {
      width: 100%;
      height: 1.74rem;
      margin-top: 0.12rem;
      overflow-x: auto;
      overflow-y: hidden;
      display: flex;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      .list-item {
        min-width: 1.57rem;
        height: 1.74rem;
        margin-right: 0.09rem;
        overflow: hidden;
        background-size: 100%;
        background-repeat: no-repeat;

        &.backgroundBg {
          background-size: 100%;
          background-repeat: no-repeat;
        }

        .item-bg {
          width: 100%;
          height: 0.76rem;
          padding-top: 0.16rem;

          .item-icon {
            width: 0.74rem;
            height: 0.49rem;
            margin: 0 auto;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .item-name {
          text-align: center;
          margin-top: 0.06rem;
          font-family: PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #3b1401;
        }

        .item-desc {
          text-align: center;
          font-family: PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #3b1401;
        }

        .item-price {
          color: #879099;
          font-family: PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          text-align: center;
          margin-top: 0;
        }

        .item-btn {
          width: 0.81rem;
          height: 0.24rem;
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          margin: 0.05rem auto 0;
          border-radius: 0.12rem;
          text-align: center;

          .normal {
            font-family: PingFang SC, sans-serif;
            font-weight: 600;
            font-size: 0.1rem;
            color: #fff;
          }

          .price {
            font-family: DIN, sans-serif;
            font-weight: 700;
            font-size: 0.16rem;
            color: #fff;
          }
        }

        &.two {
          min-width: 1.34rem;
          height: 1.74rem;
          margin-right: 0.06rem;
          background-image: url(https://m.hellobike.com/resource/gallery/350/e1aUH-A6_nba-bg-shot.png);
        }
      }
    }
  }
}
</style>
